import React from 'react';
import { Play, Youtube, Instagram } from 'lucide-react';

export const VideoPlaceholder = ({ type = 'youtube', title = 'Video Coming Soon' }) => {
  const Icon = type === 'instagram' ? Instagram : Youtube;
  
  return (
    <div 
      data-testid={`video-placeholder-${type}`}
      className="video-placeholder aspect-video flex flex-col items-center justify-center cursor-pointer group"
    >
      <div className="relative mb-4">
        <div className="w-16 h-16 rounded-full bg-white shadow-lg flex items-center justify-center group-hover:scale-110 transition-transform">
          <Play size={28} className="text-[#002A76] ml-1" fill="currentColor" />
        </div>
        <div className="absolute -bottom-2 -right-2 w-8 h-8 rounded-full bg-[#002A76] flex items-center justify-center">
          <Icon size={16} className="text-white" />
        </div>
      </div>
      <p className="text-[#002A76] font-medium text-sm">{title}</p>
      <p className="text-gray-500 text-xs mt-1">Click to watch when available</p>
    </div>
  );
};

export const VideoEmbed = ({ url, type = 'youtube' }) => {
  if (!url) return <VideoPlaceholder type={type} />;

  // Extract video ID from YouTube URL
  const getYouTubeId = (url) => {
    const match = url.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/watch\?.+&v=))([\w-]{11})/);
    return match ? match[1] : null;
  };

  // Extract Instagram embed URL
  const getInstagramEmbed = (url) => {
    if (url.includes('instagram.com')) {
      return url.includes('/embed') ? url : `${url}embed/`;
    }
    return null;
  };

  if (type === 'youtube') {
    const videoId = getYouTubeId(url);
    if (!videoId) return <VideoPlaceholder type={type} title="Invalid YouTube URL" />;
    
    return (
      <div data-testid="youtube-embed" className="aspect-video rounded-xl overflow-hidden">
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full"
        />
      </div>
    );
  }

  if (type === 'instagram') {
    const embedUrl = getInstagramEmbed(url);
    if (!embedUrl) return <VideoPlaceholder type={type} title="Invalid Instagram URL" />;
    
    return (
      <div data-testid="instagram-embed" className="rounded-xl overflow-hidden">
        <iframe
          src={embedUrl}
          title="Instagram post"
          allowFullScreen
          className="w-full min-h-[450px]"
        />
      </div>
    );
  }

  return <VideoPlaceholder type={type} />;
};

export default VideoEmbed;
